export { default } from './Txt';
export * from './Txt';
export * from './useTxtStyle';
export * from './useTxtTruncate';
// export * from './useHtmlProps'
// export * from './useTxtVariantMap'
